<!-- eslint-disable max-lines -->
<template>
    <div class="micro-app-box"  :key="keyNum">
        <micro-app name="report" :url="url"  :data="storeInfo"  disable-memory-router baseroute="/report"></micro-app>
    </div>
</template>

<script>
import { ref, getCurrentInstance, onActivated, onMounted, watch, reactive } from '@vue/composition-api';
import router from '../../../router';
import store from '@/store';
import envConfig from '@/config/user.env.js';
import microApp, { EventCenterForMicroApp } from '@micro-zoe/micro-app';
// 因为vite子应用关闭了沙箱，我们需要为子应用appname-vite创建EventCenterForMicroApp对象来实现数据通信
window.eventCenterForAppNameVite = new EventCenterForMicroApp('lineIncrementalDiagnosis');
export default {
    name: 'reportPreview',
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const ctx = getCurrentInstance();
        const keyNum = ref(1);
        const { user,
            authority,
            currentTenant,
            appId,
            tenantInfo,
            appList,
            applicationCode,
            supplier,
            btnPermissions } = store.getters;
        const storeInfo = ref({ user,
            authority,
            currentTenant,
            appId,
            tenantInfo,
            appList,
            applicationCode,
            supplier,
            btnPermissions,
            router });
        const url = ref(envConfig.reportUrl + 'report/preview');
        const isShow = ref(false);
        watch(
            () => ctx.$route,
            // eslint-disable-next-line complexity
            (val) => {
                if (val.name === 'reportPreview') {
                    isShow.value = true;
                    storeInfo.value.path = val.path;
                    storeInfo.value.query = val.query || {};
                    storeInfo.value.params = val.params || {};
                    keyNum.value += 1;
                } else {
                    isShow.value = false;
                }
            },
            { immediate: true } // 不设置的话，初始化加载时不会执行
        );
        return {
            storeInfo,
            url,
            keyNum,
            isShow
        };
    }
};
</script>
<style lang="less">

.micro-app-box {
    width: 100%;
    height: 100%;
}
.micro-app-ams .width-100 {
    height: 100%;
}
.micro-app-box {
    width: 100%;
    height: 100%;
}
.micro-app-ams {
    height: 100%;
}
</style>
